import { ViewController } from '@estee/elc-service';
import { ConfigRepository } from '../repositories/ConfigRepository';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { computed } from 'mobx';

export class RampViewController extends ViewController {
    private configRepository: ConfigRepository;

    constructor() {
        super();
        this.configRepository = diContainer.get(serviceNames.configRepository);
    }

    @computed
    get config() {
        return this.configRepository.config.config;
    }
}
